import { css } from 'lit';

export const styles = css`
  :host {
    display: block;
  }

  .parts-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: var(--sl-color-neutral-0);
    overflow: hidden;
  }





  .empty-state {
    text-align: center;
    padding: 3rem 2rem;
    color: var(--sl-color-neutral-500);
  }

  .empty-state sl-icon {
    margin-bottom: 1rem;
    color: var(--sl-color-neutral-300);
  }

  .loading {
    text-align: center;
    padding: 3rem;
    color: var(--sl-color-neutral-600);
  }

  .error {
    text-align: center;
    padding: 3rem;
    color: var(--sl-color-danger-600);
  }

  .error sl-icon {
    margin-bottom: 1rem;
  }

`;
